import { useCASL } from '@/hooks/useCASL';
import { canExportResourceActivity } from '@/shared/permissions';
import { useUserStore } from '@/stores';
import { ResourceActivityResourceType } from '@/types';

export const useResourceActivityExportAccess = (
    resourceType: ResourceActivityResourceType,
    resourceId: string,
    authorizationResourceId?: string,
) => {
    const { ability } = useCASL();
    const memberPermission = useUserStore((state) => state.selectedUser?.activeMember?.permission);

    return canExportResourceActivity({
        ability,
        authorizationResourceId,
        memberPermission,
        resourceId,
        resourceType,
    });
};
